import { render, staticRenderFns } from "./TitleCard.vue?vue&type=template&id=5ec9e8ee&"
import script from "./TitleCard.vue?vue&type=script&lang=js&"
export * from "./TitleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports